$(function () {
    let isMobile = false;

    let enterHandler = function(e) {
        if(isMobile) return;
        let $dropdown = $(this);

        $dropdown.addClass('is-open');
    };

    let leaveHandler = function(e) {
        if(isMobile) return;
        let $dropdown = $(this);

        $dropdown.removeClass('is-open');
    };

    let checkFlags = function() {
        if($(window).width() < 960.1) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    let clickOpen = function(event) {
        if(! isMobile) return;
        let $dropdownButton = $(this);
        let $dropdown = $dropdownButton.closest('.js-dropdown');

        $dropdown.addClass('is-open');
    };

    let clickClose = function(event) {
        if(! isMobile) return;
        let $dropdownButton = $(this);
        let $dropdown = $dropdownButton.closest('.js-dropdown');

        $dropdown.removeClass('is-open');
    };

    let $dropdown = $('.js-dropdown');
    let $dropdownOpen = $dropdown.find('.js-dropdown-open');
    let $dropdownClose = $dropdown.find('.js-dropdown-close');
    $dropdown.on('mouseenter', enterHandler);
    $dropdown.on('mouseleave', leaveHandler);
    $dropdownOpen.on('click', clickOpen);
    $dropdownClose.on('click', clickClose);
    checkFlags();
    $(window).on('resize', function(){
      checkFlags();
    });

    $dropdownOpen.on('click', function(event){
        if($(window).width() <= 1366) {
            event.preventDefault();
        }
    });

//show more tags

    let $tag = $('.news__tags--part .news__tags-item'),
        $showTag = $('.js-show-tags'),
        $hideTag = $('.js-hide-tags'),
        $tagCount = $tag.length;

    
    if ( $(window).width() > 768 && $tagCount > 18 ) {
        $showTag.addClass('is-show');
        $hideTag.addClass('is-show');
    } else if ($(window).width() <= 768 && $tagCount > 9){
        $showTag.addClass('is-show');
        $hideTag.addClass('is-show');
    }
    $showTag.on('click', function(event){
        event.preventDefault();
        $(this).addClass('news__tags-button--hide');
        $hideTag.removeClass('news__tags-button--hide');
        $tag.show();

    });
     $hideTag.on('click', function(event){
        event.preventDefault();
        $(this).addClass('news__tags-button--hide');
        $showTag.removeClass('news__tags-button--hide');
        $tag.hide();
    });
});


